<template>
  <div class="w-550px m-auto">
    <el-form :model="form" :rules="formRules" ref="formRef">
      <el-form-item label="上传分支" prop="branch">
        <el-select
          v-model="form.branch"
          placeholder="请选择分支"
          @change="branchChange"
        >
          <el-option
            v-for="item in branchs"
            :label="item.name"
            :value="item.id"
            :key="item.id"
          ></el-option
        ></el-select>
      </el-form-item>
      <el-form-item label="上传目录" prop="path">
        <el-autocomplete
          class="inline-input "
          v-model="form.git_folder"
          :fetch-suggestions="querySearch"
          placeholder="输入上传目录，如：/test"
          :trigger-on-focus="false"
          @select="handleSelect"
          
    ></el-autocomplete>
        <el-popover
            placement="right"
            title="提示"
            width="200"
            trigger="hover"
            style="position: absolute; right: -25px;"
          >
            <div>
              如果为空将上传至根目录<br>
              如果目录不存在将自动创建<br>
              支持多级目录，如：/test/test1<br>
              请确保目录名称符合git规范<br>
            </div>
            <img
              src="@/assets/images/information.png"
              class="w-19px h-19px ml-10px"
              slot="reference"
            />
          </el-popover>
      </el-form-item>
      
      <el-form-item label="提交说明" prop="commit">
        <el-input
          v-model="form.commit"
          placeholder="添加文件"
          show-word-limit
          :maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="上传文件" prop="file">
    
        <global-uploader
          ref="global-uploader"
          :extra-params="params"
          :fileis-disabled="fileisDisabled"
          :netdiskis-disabled="netdiskisDisabled"
          :show-all-content="showAllContent"
          @success="success"
          @saveNetDiskLink="saveNetDiskLink"
          @exist="success"
    
        />
    
      </el-form-item>
      
      <div>
   
      </div>
      <el-form-item label="">
        <div class="w-full">
          <div
            class="flex items-center"
            v-for="(item, index) in successFileLists"
            :key="index"
          >
            <span class="flex-1 truncate">{{ item.name }}</span>
            <span class="size mx-20px">{{ item.size }}</span>
            <img class="w-28px h-28px" src="@/assets/images/success.png" />
          </div>
        </div>
      </el-form-item>
      <div class="text-purple-900 text-center" v-if="flage">  
       
            <img
              src="@/assets/images/information.png"
              class="w-19px h-19px ml-10px mr-3px mt-5px"
              slot="reference"
              style="display: inline-block;"
            />
         文件正在后台处理中,请勿重复上传同一文件</div>
    </el-form>
  </div>
</template>

<script>
import GlobalUploader from '@/components/global-uploader.vue'
export default {
  components: { GlobalUploader },
  props: {
    dirlist: {
      type: Array,
      default: () => []
    },
  },
  watch: {
    dirlist(val) {    
      this.restaurants = val
    },
    'form.git_folder'(val) {
      if (val=='') {
        this.$emit('search', '',this.form.branch)
        return
      }
      const gitFolderNameRegex = /^[a-zA-Z0-9_./-]*$/ ;
        // 检查当前值是否匹配正则表达式
        if (!gitFolderNameRegex.test(val)) {
         // 如果不匹配，清除不符合规范的输入
           this.form.git_folder = val.replace(/[^\/a-zA-Z0-9._-]+/g, '')      
        }
        let path = val.replace(/^\//, '');
        const lastSlashIndex = path.lastIndexOf('/');
        if (lastSlashIndex !== -1) {
        path = path.substring(0, lastSlashIndex);
        }  
        if ((val.match(/\//g) || []).length > 1 && val[val.length - 1] === '/') {
          this.$emit('search', path, this.form.branch);
        } 
    },
  },
  data() {
    return {
      flage:false,
      restaurants:[],
      form: {
        commit: '添加文件',
        git_folder:'',
        branch: 'main',
        file: [],
        netDiskLink:'',
        branchName:'main',
        
      },
      successFileLists: [],
      formRules: {
        branch: [{ required: true, message: '请选择分支', trigger: 'change' }],
        //file: [{ required: true, message: '请上传文件', trigger: 'change' }]
        file:[{validator:this.validFile, trigger: 'change' },{validator:this.validFile, trigger: 'blur' }]
        
      },
      activePath: '',
      cancleNetDisk: false,
      fileisDisabled:false,
      netdiskisDisabled:false,
      showAllContent:true
    }
  },
  computed: {
    branchs() {
      return this.$store.state.project.branchs
    },
    project_id() {
      return this.$store.state.project.projectId
    },
    params() {
      return {
        project_id: this.project_id,
        path: this.activePath
      }
    }
  },
  created() {
    this.restaurants=this.dirlist   
  },

  mounted() {},
  methods: {
    branchChange(val) {
      let res = this.branchs.find((item) => item.id === val)
      this.form.branchName = res.name
    },
    success(data) {
      const { file, filePath } = data
      this.form.file.push(filePath)
      const { name, size } = file
      this.successFileLists.push({
        name,
        size: (size / 1024 / 1024).toFixed(1) + 'Mb'
      })
      this.netdiskisDisabled=true
    },
    finish() {
    
      return new Promise((resolve, reject) => {
        try {
        
          this.$refs['formRef'].validate((valid) => {
            if (valid) {
              this.netdiskisDisabled=false
              this.fileisDisabled=false
              this.showAllContent=true
              this.form.git_folder=this.form.git_folder.replace(/^\/+/, '');     
              resolve(this.form)
              this.flage=true
            } else {
             
              reject()
            }
          })
        } catch (error) {
         
          reject(error)
        }
      })
    },
    //设置已选的文件路径
    setactivepath(val) {
      let path = ''
      val.forEach(item => {
          path += '/'+item 
      });
      this.form.git_folder=path
    },
    closeUploader() {
      this.successFileLists = []
      this.form.file = []
      this.form.git_folder='/'+this.form.git_folder
    },
    closeListedFiles(){
       this.flage=false
 this.$refs['global-uploader'].closeUploader()

    },
    saveNetDiskLink(data){
      if(data=='cancleNetDisk'){
        //这里用于取消网盘的验证状态，既当网盘的链接不合法触发验证以后，界面会显示提示，但如果用户此时选择了文件上传，则这个提示不会自动消失
        //所以此处利用下面的变量，然后重新触发验证，并在验证里返回true,但一定要在次把这个变量cancleNetDisk，重置为false，防止后续验证都失效
          this.cancleNetDisk=true
          this.showAllContent=false
          this.$refs.formRef.validateField('file');
          return
      }
      if(data=='hideAllContent'){
        this.showAllContent=false
        return
      }
      this.form.netDiskLink=data
      this.showAllContent=false
      this.$refs.formRef.validateField('file');
      
    },
    querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
    handleSelect(item) {
        let path = item.value.replace(/^\//, '')
        this.$emit('search', path,this.form.branch)
      },
    validFile(rule,value,callback){
         if(this.cancleNetDisk){
            this.cancleNetDisk=false
            this.form.netDiskLink=''
            return
         }
         if(this.form.file.length==0 && this.form.netDiskLink==''){
          this.fileisDisabled=false
          return callback(new Error('文件或者网盘链接至少选择一项'))
         }

         if(this.form.file.length==0 && this.form.netDiskLink!=''){
          let regex = new RegExp('.*pan.baidu.com/s/.*\?pwd=.{4}$')
          console.log(this.form.netDiskLink)
          if(!regex.test(this.form.netDiskLink)){
            this.fileisDisabled=false
            return callback(new Error('请输入合法的网盘链接'))
          }
          
         }
         this.fileisDisabled=true
         return callback()
    }
  }
}
</script>
<style lang="scss" scoped>

.el-form .el-form-item__content {
  overflow-x: hidden;
}
.inline-input{
  width: 100%;
}
::v-deep{
  .inline-input .el-input__inner {
   height: 40px; 
   padding: 0 10px;
    
}
}


</style>
